import {
  MODE_APPOINTMENT,
  PRESCREENER_CATEGORY_TO_ROUTE,
  PRESCREENER_STEP_ID_TO_CATEGORY_NAME,
  PRESCREENER_STEP_ID_TO_COMPLETION_KEY,
  UNSUPPORTED_CATEGORIES,
} from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import QuestionProcessor from 'client-portal/utils/prescreener/question-processor';

import Service, { service } from '@ember/service';

export default class PrescreenerStepService extends Service {
  @service prescreener;
  @service session;
  @service request;

  currentStepIndex = 0;

  @tracked currentCategory;
  @tracked categories = [];

  get #currentCategory() {
    return this.categories[this.currentStepIndex];
  }

  updateCurrentCategory() {
    this.currentCategory = this.#currentCategory;
  }

  updateCategories() {
    this.categories = new QuestionProcessor({
      prescreener: this.prescreener,
      formType: MODE_APPOINTMENT,
      excludeCategories: UNSUPPORTED_CATEGORIES,
    }).categories;
    this.updateCurrentCategory();
  }

  getFirstCategoryRoute(baseRouteName) {
    if (this.categories.length === 0) {
      return null;
    }
    const firstCategory = this.categories[0];
    return this.getCategoryRoute(firstCategory, baseRouteName);
  }

  getCategoryRoute(category, baseRouteName) {
    const routeName = PRESCREENER_CATEGORY_TO_ROUTE[category];
    return routeName ? `${baseRouteName}.${routeName}` : null;
  }

  getNextCategoryRoute(currentRouteName) {
    const isCategoryRoute = currentRouteName.includes('prescreener-');

    if (!isCategoryRoute) {
      return null;
    }

    const lastPart = currentRouteName.split('.').pop();

    const currentIndex = this.categories.findIndex(
      category => PRESCREENER_CATEGORY_TO_ROUTE[category] === lastPart
    );

    if (currentIndex === -1) {
      return null;
    }

    const nextIndex = currentIndex + 1;

    if (nextIndex < this.categories.length) {
      const nextCategory = this.categories[nextIndex];
      return PRESCREENER_CATEGORY_TO_ROUTE[nextCategory];
    }
    return null;
  }

  getFirstPrescreenerRoute() {
    let baseRouteName = this.request.baseRouteName;
    const firstCategoryRoute = this.getFirstCategoryRoute(baseRouteName);
    return firstCategoryRoute || `${baseRouteName}.information`;
  }

  processPrescreenerSteps(reservation, activeSteps) {
    const filteredSteps = activeSteps.filter(step => {
      const categoryName = PRESCREENER_STEP_ID_TO_CATEGORY_NAME[step.id];

      if (!categoryName) return true;

      return this.categories.includes(categoryName);
    });

    filteredSteps.forEach(step => {
      const completionKey = PRESCREENER_STEP_ID_TO_COMPLETION_KEY[step.id];
      if (completionKey) {
        step.set('completedKey', completionKey);
      }
    });

    return filteredSteps;
  }

  @action
  goToCategory(category) {
    const stepIndex = this.categories.findIndex(cat => cat === category);
    if (stepIndex >= 0 && stepIndex < this.categories.length) {
      this.currentStepIndex = stepIndex;
    }
    this.updateCurrentCategory();
  }
}
